import {
  Injector,
  ElementRef,
  Component,
  OnDestroy,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import {
  Router,
  RouterModule
} from '@angular/router';

import { Subscription } from 'rxjs/Subscription';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

import {
  DialogService,
  OUserInfoService,
  UserInfo,
  LoginService
} from '../../services';

export const DEFAULT_INPUTS_O_USER_INFO = [];

export const DEFAULT_OUTPUTS_O_USER_INFO = [];



export class OUserInfoComponent implements OnDestroy {
  public static DEFAULT_INPUTS_O_USER_INFO = DEFAULT_INPUTS_O_USER_INFO;
  public static DEFAULT_OUTPUTS_O_USER_INFO = DEFAULT_OUTPUTS_O_USER_INFO;

  protected dialogService: DialogService;
  protected loginService: LoginService;
  protected oUserInfoService: OUserInfoService;

  userInfoSubscription: Subscription;
  protected userInfo: UserInfo;

  constructor(
    protected elRef: ElementRef,
    protected injector: Injector,
    private router: Router
  ) {
    this.dialogService = this.injector.get(DialogService);
    this.loginService = this.injector.get(LoginService);
    this.oUserInfoService = this.injector.get(OUserInfoService);

    this.userInfo = this.oUserInfoService.getUserInfo();
    this.userInfoSubscription = this.oUserInfoService.getUserInfoObservable().subscribe(res => {
      this.userInfo = res;
    });
  }

  ngOnDestroy() {
    this.userInfoSubscription.unsubscribe();
  }

  onLogoutClick() {
    this.loginService.logoutWithConfirmationAndRedirect();
  }

  onSettingsClick() {
    this.router.navigate(['main/settings']);
  }

  get existsUserInfo() : boolean {
    return this.userInfo !== undefined;
  }
  get avatar() : string {
    return this.userInfo ? this.userInfo.avatar : undefined;
  }

  get username() : string {
    return this.userInfo ? this.userInfo.username : undefined;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-user-info',
  inputs: DEFAULT_INPUTS_O_USER_INFO,
  outputs: DEFAULT_OUTPUTS_O_USER_INFO,
  template: `
    <div class="user-info-container" fxLayout="column" fxLayoutAlign="center" *ngIf="existsUserInfo">
      <div class="user-info-wrapper" fxLayout="row" fxLayoutAlign="center center" [mdMenuTriggerFor]="menu">
        <div fxLayout="row" fxLayoutAlign="center center" class="user-info-avatar-wrapper">
          <img [src]="avatar" *ngIf="avatar" />
        </div>
        <span class="user-info-username" *ngIf="username"> {{ username }}</span>
        <md-icon>keyboard_arrow_down</md-icon>
      </div>
      <md-menu #menu="mdMenu" yPosition="below">
        <button md-menu-item (click)="onSettingsClick()">
          <md-icon>settings</md-icon>
          <span>{{ 'SETTINGS' | oTranslate }}</span>
        </button>
        <button md-menu-item (click)="onLogoutClick()">
          <md-icon>power_settings_new</md-icon>
          <span>{{ 'LOGOUT' | oTranslate }}</span>
        </button>
      </md-menu>
    </div>
  `,
  styles: [`
    .user-info-container{cursor:pointer;height:100%}.user-info-container .user-info-avatar-wrapper{width:30px;height:30px;overflow:hidden;border-radius:100%}.user-info-container .user-info-avatar-wrapper img{max-width:100%;height:auto}.user-info-container .user-info-username{padding-left:6px}.user-info-container md-icon{padding-left:4px;font-size:16px;line-height:26px}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Injector, },
{type: Router, },
];
}


export class OUserInfoModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OUserInfoComponent],
  imports: [OSharedModule, CommonModule, RouterModule],
  exports: [OUserInfoComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
